// src/components/store/sections/hero-banner/HeroV86PodiumspotlightIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV86PodiumspotlightIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={86}
      archKey="podium_spotlight"
      archLabel="3D Podium Spotlight"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
